<template>
  <div class="home mt-3">
    <filtros-box
      entidad="Integrador"
      @modelActivo="integrador_activo = $event"
      @model="integrador_sel = $event"
      @muestraModal="showEdit($event[0], $event[1])"
      @buscar="getIntegradoresBusqueda()"
    >
    </filtros-box>

    <div class="alert alert-success" role="alert" v-if="success">
      {{ success }}
    </div>
    <div class="alert alert-danger" role="alert" v-if="error">{{ error }}</div>

    <data-table
      v-if="integradoresBusqueda && integradoresBusqueda.data.length"
      :columns="columns"
      :data="integradoresBusqueda.data"
      :order-by-field="orderByField"
      :order-by-direction="orderByDirection"
      id-key="id_integrador"
      @sort="orderByfield"
    >
      <template #cell-ctr_events="{ item, value }">
        <div class="text-left" style="min-width: 140px;">
          <template v-if="!value || formatCtrEvents(value) === '-'">
            <span class="text-muted">-</span>
          </template>
          <template v-else>
            <span :title="formatCtrEvents(value)">
              {{ getTruncatedEvents(formatCtrEvents(value), 35) }}
            </span>
            <a
              v-if="shouldTruncateEvents(formatCtrEvents(value), 35)"
              href="#"
              class="ml-1 text-primary font-weight-bold"
              style="font-size: 0.8rem; cursor: pointer; white-space: nowrap; text-decoration: underline;"
              :title="formatCtrEvents(value)"
              @click.prevent="showTooltip($event, item, formatCtrEvents(value))"
            >
              ver más
            </a>
          </template>
        </div>
      </template>

      <template #actions="{ item }">
        <table-actions
          :item="item"
          active-key="activo"
          @edit="showEdit(item, 'edit')"
          @toggle="showEdit(item, 'toggle')"
        />
      </template>
    </data-table>
    <Paginador
      v-if="integradoresBusqueda && integradoresBusqueda.pages"
      :pages="integradoresBusqueda.pages"
      @selPage="changePage"
    ></Paginador>
    <empty-state
      :show="Boolean(post && integradoresBusqueda && integradoresBusqueda.data && !integradoresBusqueda.data.length)"
      message="No se encontraron integradores que coincidan con la búsqueda."
    />
    <div v-if="error">{{ error.message }}</div>
    <!-- Modal -->
    <div v-if="showModal">
      <transition name="modal">
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div
              class="modal-dialog modal-dialog-scrollable"
              role="document"
              :class="
                operation == 'jerarquia'
                  ? 'modal-lg modal-dialog-scrollable'
                  : ''
              "
            >
              <div class="modal-content">
                <div class="modal-header">
                  <h5 v-if="operation == 'toggle'" class="modal-title">
                    <span v-if="editData.activo == 1"> Suspender Integrador</span>
                    <span v-if="editData.activo == 0"> Reactivar Integrador</span>
                  </h5>
                  <h5 v-if="operation == 'edit'" class="modal-title">
                    Editar Integrador {{ editData.id_integrador }}
                  </h5>
                  <h5 v-if="operation == 'add'" class="modal-title">
                    Nuevo Integrador
                  </h5>
                  <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    aria-label="Close"
                    @click="closeModal"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body">
                  <form
                    v-if="
                      operation == 'toggle' ||
                        operation == 'edit' ||
                        operation == 'add'
                    "
                  >
                   

                    <div class="form-group">
                      <label>
                        Integrador
                        <span v-if="operation == 'edit' || operation == 'add'" class="text-danger">*</span>
                      </label>
                      <b class="form-control" v-if="operation == 'toggle'">{{
                        editData.integrador
                      }}</b>
                      <input
                        class="form-control"
                        v-if="operation == 'edit' || operation == 'add'"
                        type="text"
                        placeholder="Ej: Movistar, Claro, Entel"
                        v-model="editData.integrador"
                        required
                      />
                      <small class="form-text text-muted">Nombre del integrador asociado.</small>
                    </div>

                    <div class="form-group">
                      <label>Endpoint para CTRs</label>
                      <b class="form-control" v-if="operation == 'toggle'">{{
                        editData.ctr_url || editData.endpoint_eventos || editData.endpoint || '-'
                      }}</b>
                      <input
                        class="form-control"
                        v-if="operation == 'edit' || operation == 'add'"
                        type="url"
                        placeholder="Ej: https://midominio.com/api/ctr"
                        v-model="editData.ctr_url"
                      />
                      <small class="form-text text-muted">URL o endpoint donde se enviarán las notificaciones de CTRs.</small>
                    </div>

                    <div class="form-group">
                      <div class="d-flex justify-content-between align-items-center mb-1">
                        <label class="mb-0">Eventos de CTRs</label>
                        <div v-if="operation == 'edit' || operation == 'add'">
                          <button
                            type="button"
                            class="btn btn-outline-primary btn-sm py-0 px-2 mr-1"
                            style="font-size: 0.75rem;"
                            @click="selectAllEvents"
                          >
                            Seleccionar todos
                          </button>
                          <button
                            type="button"
                            class="btn btn-outline-secondary btn-sm py-0 px-2"
                            style="font-size: 0.75rem;"
                            @click="clearAllEvents"
                          >
                            Limpiar
                          </button>
                        </div>
                      </div>

                      <!-- Modo lectura (toggle / vista) -->
                      <div v-if="operation == 'toggle'" class="p-2 border rounded bg-light">
                        <div v-if="editData.selectedEvents && editData.selectedEvents.length" class="d-flex flex-wrap">
                          <span
                            v-for="id in editData.selectedEvents"
                            :key="id"
                            class="badge badge-info mr-1 mb-1 px-2 py-1"
                          >
                            {{ getEventName(id) }}
                          </span>
                        </div>
                        <span v-else class="text-muted small">Sin eventos seleccionados</span>
                      </div>

                      <!-- Modo edición / creación -->
                      <div v-else>
                        <small class="form-text text-muted mb-2">Seleccione los eventos CTR a notificar:</small>
                        <div
                          class="border rounded p-2"
                          style="max-height: 180px; overflow-y: auto; background-color: #f8f9fa;"
                        >
                          <div class="row">
                            <div
                              class="col-sm-6 mb-2"
                              v-for="evt in listaEventosCtr"
                              :key="evt.id"
                            >
                              <div class="custom-control custom-checkbox">
                                <input
                                  type="checkbox"
                                  class="custom-control-input"
                                  :id="'evt_' + evt.id"
                                  :value="evt.id"
                                  v-model="editData.selectedEvents"
                                />
                                <label
                                  class="custom-control-label"
                                  :for="'evt_' + evt.id"
                                  style="cursor: pointer; font-size: 0.85rem;"
                                >
                                  {{ evt.label || evt.nombre }}
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                        <small class="form-text text-muted mt-1">
                          {{ (editData.selectedEvents || []).length }} evento(s) seleccionado(s)
                        </small>
                      </div>
                    </div>

                    <div v-if="errors" class="alert alert-danger" role="alert">
                      {{ errors }}
                    </div>
                  </form>
                </div>
                <div class="modal-footer">
                  <button
                    type="button"
                    class="btn btn-secondary"
                    @click="closeModal"
                  >
                    <span v-if="operation == 'jerarquia'">Cerrar</span>
                    <span v-else>Cancelar</span>
                  </button>
                  <button
                    type="button"
                    v-if="operation == 'toggle'"
                    @click="toggleStatus"
                    class="btn btn-primary"
                  >
                    <span v-if="editData.activo == 1"> Suspender</span>
                    <span v-if="editData.activo == 0"> Reactivar</span>
                  </button>
                  <button
                    type="button"
                    v-if="operation == 'edit'"
                    @click="editIntegrador"
                    class="btn btn-primary"
                  >
                    Guardar
                  </button>
                  <button
                    type="button"
                    v-if="operation == 'add'"
                    @click="agregarIntegrador"
                    class="btn btn-primary"
                  >
                    Guardar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>

    <!-- Tooltip / Popover flotante para Eventos CTRs -->
    <div
      v-if="activeTooltip.visible"
      class="events-popover-tooltip shadow-lg border rounded p-2"
      :style="{
        position: 'fixed',
        top: activeTooltip.top + 'px',
        left: activeTooltip.left + 'px',
        zIndex: 1060,
        width: '320px',
        maxWidth: '90vw',
        backgroundColor: '#ffffff'
      }"
    >
      <div class="d-flex justify-content-between align-items-center border-bottom pb-1 mb-2">
        <span class="font-weight-bold small text-dark">
          <i class="bi bi-info-circle-fill text-primary mr-1"></i>
          {{ activeTooltip.title }}
        </span>
        <button
          type="button"
          class="close"
          style="font-size: 1.1rem; line-height: 1; padding: 0 4px;"
          @click="closeTooltip"
        >
          &times;
        </button>
      </div>
      <div class="small text-secondary" style="max-height: 180px; overflow-y: auto; line-height: 1.4;">
        {{ activeTooltip.content }}
      </div>
    </div>
    <div
      v-if="activeTooltip.visible"
      class="tooltip-backdrop"
      style="position: fixed; top: 0; left: 0; width: 100vw; height: 100vh; z-index: 1055; background: transparent;"
      @click="closeTooltip"
    ></div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "axios";
import Swal from "sweetalert2/dist/sweetalert2.js";
import Paginador from "./Paginador.vue";
import filtrosBox from "./utiles/filtrosBox.vue";
import DataTable from "./utiles/DataTable.vue";
import TableActions from "./utiles/TableActions.vue";
import EmptyState from "./utiles/EmptyState.vue";
import { tableSortMixin } from "@/mixins/tableSortMixin";

export default {
  name: "Integradores",
  mixins: [tableSortMixin],

  data() {
    return {
      columns: [
        { label: "Id", field: "id_integrador", width: "60" },
        { label: "Integrador", field: "integrador" },
        {
          label: "Endpoint CTRs",
          field: "ctr_url",
          formatter: (val, item) => val || (item && (item.ctr_url || item.endpoint_eventos || item.endpoint)) || "-"
        },
        {
          label: "Eventos CTRs",
          field: "ctr_events",
          formatter: (val, item) => this.formatCtrEvents(val || (item && item.ctr_events))
        },
        { label: "Estado", field: "activo", type: "badge", width: "110" },
      ],
      listaEventosCtr: [],
      activeTooltip: {
        visible: false,
        title: "",
        content: "",
        top: 0,
        left: 0,
        itemId: null
      },
      success: null,
      error: null,
      integrador_sel: null,
      integrador_activo: 1,
      integradoresBusqueda: null,
      post: false,
      showModal: false,
      editData: null,
      operation: null,
      page: 1,
      errors: null
    };
  },

  components: {
    DataTable,
    Paginador,
    filtrosBox,
    TableActions,
    EmptyState,
  },

  created() {
    this.getEventosCtr();
    this.getIntegradoresBusqueda();
  },
  computed: {
    ...mapGetters("auth", ["user"])
  },
  methods: {
    changePage: function(page) {
      this.page = page;
      this.getIntegradoresBusqueda(false);
    },

    orderByfield: function (field) {
      this.toggleOrder(field);
      this.getIntegradoresBusqueda(false);
    },
    getIntegradoresBusqueda: function(hideResult = true) {
      if (hideResult) this.integradoresBusqueda = null;
      this.post = false;
      this.$store.commit("setLoading", true);
      axios
        .post(process.env.VUE_APP_API_URL + "integrador/busqueda", {
          page: this.page,
          integrador: this.integrador_sel,
          activo: this.integrador_activo,
          order_by: { field: this.orderByField, order: this.orderByDirection }
        })
        .then(response => {
          this.integradoresBusqueda = response.data;
        })
        .catch(e => {
          this.errors.push(e);
        })
        .finally(() => {
          this.$store.commit("setLoading", false);
          this.post = true;
        });
    },
   
    getEventosCtr: function() {
      axios
        .get(process.env.VUE_APP_API_URL + "integrador/eventos")
        .then(response => {
          if (response && response.data && response.data.data) {
            this.listaEventosCtr = response.data.data;
            if (
              this.operation === "add" &&
              this.editData &&
              (!this.editData.selectedEvents || !this.editData.selectedEvents.length)
            ) {
              this.$set(
                this.editData,
                "selectedEvents",
                this.listaEventosCtr.map(e => e.id)
              );
            }
          }
        })
        .catch(() => {
          this.listaEventosCtr = [];
        });
    },

    getEventName: function(id) {
      if (!this.listaEventosCtr || !this.listaEventosCtr.length) {
        return `Evento ${id}`;
      }
      const evt = this.listaEventosCtr.find(e => Number(e.id) === Number(id));
      return evt ? (evt.label || evt.nombre) : `Evento ${id}`;
    },

    formatCtrEvents: function(val) {
      if (!val) return "-";
      let ids = [];
      if (Array.isArray(val)) {
        ids = val.map(x => parseInt(x, 10)).filter(x => !isNaN(x));
      } else if (typeof val === "string") {
        ids = val.split(",").map(x => parseInt(x.trim(), 10)).filter(x => !isNaN(x));
      }
      if (!ids.length) return "-";
      return ids.map(id => this.getEventName(id)).join(", ");
    },

    showTooltip: function(event, item, fullText) {
      if (this.activeTooltip.visible && this.activeTooltip.itemId === item.id_integrador) {
        this.closeTooltip();
        return;
      }
      const rect = event.target.getBoundingClientRect();
      const tooltipWidth = 320;
      let left = rect.left + (rect.width / 2) - (tooltipWidth / 2);
      if (left < 15) left = 15;
      if (left + tooltipWidth > window.innerWidth - 15) {
        left = window.innerWidth - tooltipWidth - 15;
      }
      let top = rect.bottom + 6;
      if (top + 200 > window.innerHeight) {
        top = Math.max(10, rect.top - 180);
      }
      this.activeTooltip = {
        visible: true,
        title: item.integrador ? `Eventos CTRs (${item.integrador})` : "Eventos CTRs",
        content: fullText,
        top: Math.max(10, top),
        left: Math.max(10, left),
        itemId: item.id_integrador
      };
    },

    closeTooltip: function() {
      this.activeTooltip = {
        visible: false,
        title: "",
        content: "",
        top: 0,
        left: 0,
        itemId: null
      };
    },

    shouldTruncateEvents: function(text, maxLength = 45) {
      return Boolean(text && text.length > maxLength);
    },

    getTruncatedEvents: function(text, maxLength = 45) {
      if (!text || text.length <= maxLength) return text;
      return text.substring(0, maxLength).trimEnd() + "...";
    },

    selectAllEvents: function() {
      if (this.editData && this.listaEventosCtr) {
        this.$set(this.editData, "selectedEvents", this.listaEventosCtr.map(e => e.id));
      }
    },

    clearAllEvents: function() {
      if (this.editData) {
        this.$set(this.editData, "selectedEvents", []);
      }
    },

    editIntegrador: function() {
      this.errors = null;
      if (!this.editData || !this.editData.integrador || !this.editData.integrador.trim()) {
        this.errors = "El nombre del integrador es obligatorio y no puede estar en blanco.";
        return;
      }
      this.$store.commit("setLoading", true);
      const eventsStr = (this.editData.selectedEvents || []).slice().sort((a, b) => a - b).join(",");
      const payload = {
        ...this.editData,
        ctr_url: this.editData.ctr_url || "",
        ctr_events: eventsStr,
        endpoint_eventos: this.editData.ctr_url || "",
        endpoint: this.editData.ctr_url || "",
      };
      axios
        .post(process.env.VUE_APP_API_URL + "integrador/update", payload)
        .then(response => {
          if (
            response &&
            response.data &&
            response.data.errno &&
            response.data.errno > 0
          ) {
            this.errors = response.data.error;
          } else {
            Swal.fire({
              title: "Bien!",
              text: "Integrador actualizado correctamente",
              icon: "success",
              confirmButtonText: "Aceptar"
            });
            this.showModal = false;
            this.operation = null;
            this.editData = null;
          }
        })
        .catch(e => {
          if (e.response && e.response.data && e.response.data.error) {
            this.errors = e.response.data.error;
          } else {
            Swal.fire({
              title: "Error!",
              text: "Ha ocurrido un error al intentar guardar",
              icon: "error",
              confirmButtonText: "Aceptar"
            });
          }
        })
        .finally(() => {
          this.$store.commit("setLoading", false);
          if (this.operation == null) this.getIntegradoresBusqueda();
        });
    },

    toggleStatus: function() {
      this.errors = null;
      this.$store.commit("setLoading", true);
      this.editData.activo = 1 - this.editData.activo;
      axios
        .post(process.env.VUE_APP_API_URL + "integrador/update", this.editData)
        .then(response => {
          if (
            response &&
            response.data &&
            response.data.errno &&
            response.data.errno > 0
          ) {
            this.errors = response.data.error;
          } else {
            this.showModal = false;
            this.operation = null;
            this.editData = null;
          }
        })
        .catch(e => {
          if (e.response && e.response.data && e.response.data.error) {
            this.errors = e.response.data.error;
          } else {
            Swal.fire({
              title: "Error!",
              text: "Ha ocurrido un error al intentar guardar",
              icon: "error",
              confirmButtonText: "Aceptar"
            });
          }
        })
        .finally(() => {
          this.$store.commit("setLoading", false);
          if (this.operation == null) this.getIntegradoresBusqueda();
        });
    },

    showEdit: function(item, operation) {
      this.errors = null;
      this.editData = Object.assign({}, item);
      const rawEvents = this.editData.ctr_events;
      let parsedEvents = [];
      if (Array.isArray(rawEvents)) {
        parsedEvents = rawEvents.map(x => parseInt(x, 10)).filter(x => !isNaN(x));
      } else if (rawEvents && typeof rawEvents === "string") {
        parsedEvents = rawEvents.split(",").map(x => parseInt(x.trim(), 10)).filter(x => !isNaN(x));
      }
      this.$set(this.editData, "selectedEvents", parsedEvents);
      this.$set(this.editData, "ctr_url", this.editData.ctr_url || this.editData.endpoint_eventos || this.editData.endpoint || "");

      if (operation === "add") {
        if (!this.editData.integrador) this.editData.integrador = "";
        this.editData.ctr_url = "";
        const allEventIds =
          this.listaEventosCtr && this.listaEventosCtr.length
            ? this.listaEventosCtr.map(e => e.id)
            : [];
        this.$set(this.editData, "selectedEvents", allEventIds);
      }
      this.showModal = true;
      this.operation = operation;
    },

    agregarIntegrador: function() {
      this.errors = null;
      if (!this.editData || !this.editData.integrador || !this.editData.integrador.trim()) {
        this.errors = "El nombre del integrador es obligatorio y no puede estar en blanco.";
        return;
      }
      this.$store.commit("setLoading", true);
      const eventsStr = (this.editData.selectedEvents || []).slice().sort((a, b) => a - b).join(",");
      const payload = {
        ...this.editData,
        ctr_url: this.editData.ctr_url || "",
        ctr_events: eventsStr,
        endpoint_eventos: this.editData.ctr_url || "",
        endpoint: this.editData.ctr_url || "",
      };
      axios
        .post(process.env.VUE_APP_API_URL + "integrador/new", payload)
        .then(response => {
          if (
            response &&
            response.data &&
            response.data.errno &&
            response.data.errno > 0
          ) {
            this.errors = response.data.error;
          } else {
            Swal.fire({
              title: "Bien!",
              text: "Integrador creado correctamente",
              icon: "success",
              confirmButtonText: "Aceptar"
            });
            this.showModal = false;
            this.operation = null;
            this.editData = null;
          }
        })
        .catch(e => {
          if (e.response && e.response.data && e.response.data.error) {
            this.errors = e.response.data.error;
          } else {
            Swal.fire({
              title: "Error!",
              text: "Ha ocurrido un error al intentar guardar",
              icon: "error",
              confirmButtonText: "Aceptar"
            });
          }
        })
        .finally(() => {
          this.$store.commit("setLoading", false);
          if (this.operation == null) this.getIntegradoresBusqueda();
        });
    },

    closeModal() {
      this.showModal = false;
      this.operation = null;
    }
  }
};
</script>

<style scoped></style>
